module.exports = __webpack_public_path__ + "img/13.387b27ef.jpg";